// opt-out of image optimization, no-op
export const customLoader = ({ src }: {src: string}): string => {
    return src
}